import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-vertical-dark",
  "use": "arrow-vertical-dark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-vertical-dark\">\r\n<path d=\"M11.3639 3.78607L8.18603 0.599976M8.18603 0.599976L4.99994 3.78607M8.18603 0.599976V7\" stroke=\"#434343\" stroke-linejoin=\"round\" />\r\n<path d=\"M4.99994 12.248L8.17781 15.4341M8.17781 15.4341L11.3639 12.248M8.17781 15.4341V9\" stroke=\"#434343\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol